import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  Breakpoint,
  MediaQueryService
} from 'app/services/media-query.service';
import { Observable } from 'rxjs';
import { DeveloperStateService } from 'app/states/developer-state.service';
import { DeveloperService } from 'app/services/developer.service';

@Component({
  selector: 'app-side-insight',
  templateUrl: './side-insight.component.html',
  styleUrls: ['./side-insight.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideInsightComponent implements OnInit, OnChanges {
  @Input() selectedDeveloperName: any;
  @Input() selectedDate = '';
  @Input() navigateTo = 'overview';

  @Output() navCloseClick: EventEmitter<Event> = new EventEmitter();

  @HostBinding('class.open') @Input() showInsight: boolean;

  tablet$: Observable<boolean>;

  data: any;
  loadingData = false;

  constructor(
    private _developerStateService: DeveloperStateService,
    private mediaQuery: MediaQueryService,
    private element: ElementRef,
    private _developerService: DeveloperService,
    private _changeDetector: ChangeDetectorRef
  ) {
    this.tablet$ = this.mediaQuery.lt(Breakpoint.lg);
    this._onModalClick = this._onModalClick.bind(this);
  }

  ngOnInit(): void {
    this._developerStateService.developer$.subscribe(data => {
      this.data = data;
      this._changeDetector.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showInsight) {
      if (changes.showInsight.currentValue) {
        this.element.nativeElement.addEventListener(
          'click',
          this._onModalClick
        );
      } else {
        this.element.nativeElement.removeEventListener(
          'click',
          this._onModalClick
        );
      }
    }

    if (
      (changes.selectedDeveloperName &&
        changes.selectedDeveloperName.currentValue) ||
      (changes.selectedDate && changes.selectedDate.currentValue)
    ) {
      this.getDeveloperData();
    }

    if (changes.navigateTo && changes.navigateTo.currentValue) {
      this.scrollToSection(changes.navigateTo.currentValue);
    }
  }

  private getDeveloperData() {
    this.loadingData = true;
    if (this.selectedDate && this.selectedDeveloperName) {
      void this._developerService
        .getDeveloperData(this.selectedDeveloperName, this.selectedDate)
        .then(response => {
          this.loadingData = false;
          this._developerStateService.setDeveloper(response);
        });
    }
  }

  private _onModalClick(evt) {
    const modal = document.querySelector('#sideInsightContent');
    const clickInside = modal.contains(evt.target);

    if (clickInside) {
      return;
    }

    this.navCloseClick.emit(evt);
    evt.preventDefault();
  }

  private scrollToSection(key: string, behavior: ScrollBehavior = 'smooth') {
    const intervalId = setInterval(() => {
      const matchingSectionEl = document.getElementById(key);
      if (matchingSectionEl) {
        clearInterval(intervalId);
        matchingSectionEl.scrollIntoView({ behavior });
      }
    }, 100);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 3000);
  }

  @HostListener('window:keydown.escape', ['$event'])
  closeButtonClick(evt: KeyboardEvent) {
    this.navCloseClick.emit(evt);
  }
}
